export default function routerLocation(state) {
  return state.router && state.router.location;
}
